import React, { Component } from 'react';
import PropTypes from 'prop-types';

import _isNaN from 'lodash/isNaN';

import './style.scss';

export default class Pagination extends Component {
  static propTypes = {
    count: PropTypes.number.isRequired,
    paginationOptions: PropTypes.shape({
      page: PropTypes.number,
      size: PropTypes.number,
    }).isRequired,
    className: PropTypes.string,
    getItems: PropTypes.func.isRequired,
  };

  static defaultProps = {
    className: '',
  };

  calculatePagesNumber = () =>
    Math.ceil(this.props.count / this.props.paginationOptions.size);

  handleChange = e => {
    const page = parseInt(e.target.value, 10);
    const pagesNumber = this.calculatePagesNumber();

    if (!_isNaN(page) && page <= pagesNumber) {
      this.props.getItems({ page });
    }
  };

  render() {
    const { paginationOptions, className, getItems } = this.props;
    const pagesNumber = this.calculatePagesNumber();

    /* eslint-disable jsx-a11y/anchor-has-content, jsx-a11y/no-static-element-interactions, jsx-a11y/anchor-is-valid, jsx-a11y/click-events-have-key-events */
    return (
      <div className={className} styleName="pagination" data-test="pagination">
        <a
          disabled={paginationOptions.page === 1}
          className="icon-first-page"
          styleName="pagination__item is-first"
          onClick={() => getItems({ page: 1 })}
          data-test="first"
        />

        <a
          disabled={paginationOptions.page === 1}
          styleName="pagination__item is-previous"
          className="icon-previous-page"
          onClick={() => getItems({ page: +paginationOptions.page - 1 })}
          data-test="previous"
        />

        <span styleName="pagination__item">
          <input
            type="number"
            min={1}
            max={pagesNumber}
            disabled={pagesNumber === 1}
            value={paginationOptions.page}
            onChange={this.handleChange}
            data-test="current"
          />
        </span>

        <span styleName="pagination__item">of {pagesNumber}</span>

        <a
          disabled={paginationOptions.page === pagesNumber}
          styleName="pagination__item is-next"
          className="icon-next-page"
          onClick={() => getItems({ page: +paginationOptions.page + 1 })}
          data-test="next"
        />

        <a
          disabled={paginationOptions.page === pagesNumber}
          styleName="pagination__item is-last"
          className="icon-last-page"
          onClick={() => getItems({ page: pagesNumber })}
          data-test="last"
        />
      </div>
    );
  }
}
